import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { EosListRoutingModule } from './eos-list-routing.module';
import { EosListComponent } from './eos-list.component';


@NgModule({
  declarations: [EosListComponent, EosListRoutingModule.components],
  imports: [
    CommonModule, EosListRoutingModule, MDBBootstrapModulesPro.forRoot(), FormsModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class EosListModule { }
